import React from 'react';

interface State { error: Error | null }

/**
 * Catches a render crash in one page so the admin sees a message and a way out
 * instead of a blank screen. Layout keys it by route, so navigating elsewhere
 * clears the error.
 */
export default class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('Page crashed:', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div role="alert" data-testid="page-error" style={{ maxWidth: 520, margin: '60px auto', textAlign: 'center', background: '#fff', borderRadius: 12, padding: 28, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', fontFamily: "'Poppins', sans-serif" }}>
        <h3 style={{ margin: 0, color: '#1B3A5C' }}>Something went wrong on this page</h3>
        <p style={{ color: '#6b7c8a', fontSize: 13, margin: '10px 0 18px' }}>The rest of the dashboard is fine. Try again, or go back to the dashboard.</p>
        <button onClick={() => this.setState({ error: null })} style={{ padding: '8px 14px', borderRadius: 8, border: '1px solid #D5DCE4', background: '#fff', cursor: 'pointer', marginRight: 8, fontFamily: 'inherit' }}>Try again</button>
        <a href="/" style={{ padding: '8px 14px', borderRadius: 8, background: '#1B3A5C', color: '#fff', textDecoration: 'none', fontSize: 14 }}>Go to dashboard</a>
      </div>
    );
  }
}
